import { apis, actions, mutations } from '../constants'
import Store from '../Store'
export default function (ajax) {
  const store = new Store({
    state: {
      ignores: [],
      config: []
    },
    mutations: {
      [mutations.dataview.setIgnores] (state, ignores) {
        state.ignores = ignores
      },
      [mutations.dataview.setConfig] (state, config) {
        state.config = config
      },
      [mutations.dataview.addConfig] (state, config) {
        state.config.push(config)
      },
      [mutations.dataview.delConfig] (state, id) {
        state.config.forEach((config, i) => {
          if (config.id === id) {
            state.config.splice(i, 1)
          }
        })
      }
    },
    actions: {
      [actions.dataview.getIgnoreConfig] (context, appId) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.dataview.getIgnoreConfig,
            method: 'get',
            params: {
              appId
            }
          })
            .then(res => {
              context.commit(mutations.dataview.setIgnores, res.data)
              resolve(res)
            })
            .catch(reject)
            .finally(() => {
              store.setReady(context, 'ignores', true)
            })
        })
      },
      [actions.dataview.getConfig] (context, params) {
        context.commit(mutations.dataview.setConfig, [])
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.dataview.getConfig,
            method: 'get',
            params
          })
            .then(res => {
              context.commit(mutations.dataview.setConfig, res.data)
              resolve()
            })
            .catch(reject)
        })
      },
      [actions.dataview.addConfig] (context, param) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.dataview.getConfig,
            method: 'post',
            data: param
          })
            .then(res => {
              context.commit(mutations.dataview.addConfig, res.data)
              resolve(res)
            })
            .catch(reject)
        })
      },
      [actions.dataview.delConfig] (context, id) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.dataview.getConfig,
            method: 'delete',
            params: {
              id
            }
          })
            .then(() => {
              context.commit(mutations.dataview.delConfig, id)
              resolve()
            })
            .catch(reject)
        })
      },
      [actions.dataview.queryChartType] (context, appId) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.dataview.chartType,
            method: 'get',
            params: {
              appId
            }
          })
            .then(resolve)
            .catch(reject)
        })
      },
      [actions.dataview.updateChartType] (
        context,
        data = {
          appId: '',
          target: '',
          type: ''
        }
      ) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.dataview.chartType,
            method: 'post',
            data
          })
            .then(resolve)
            .catch(reject)
        })
      },
      [actions.dataview.getGeo] () {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.dataview.getGeo,
            method: 'get'
          })
            .then(resolve)
            .catch(reject)
        })
      }
    }
  })
  return store
}
